import React from 'react';
import { Checkbox, Collapse } from 'antd';

const Panel = Collapse.Panel;


/**
 * Проверка на установку галки в чекбоксе
 */
const hasChecked = (server, selected) =>{
  return (selected)? selected.filter(item => item==server).length>0: false;  
}

/** Отображение  списка типов объектов, которые могут использоваться для фильтрации.
*/
class ServerFilter extends React.Component {	

  onChangeServerUri(e, serverUri) {
    e.preventDefault();
    const {onChange} = this.props;
    if (onChange) 
      onChange(serverUri);
  };

  onChangeНighlight(e){
    e.preventDefault();
  };

  render() {
    const {uriServers, selected} = this.props;
    //console.log(this);
    return (
      <span className="csi_taxonomy" >
        <Collapse defaultActiveKey={['1', '2']} >        
        <Panel header={"Фильтр"} key="1" onClick={(e) => e.stopPropagation()}>
        {uriServers && uriServers.map((item, i) => { 
          const isChecked = hasChecked(item.server, selected);
          return (
            <p key={i}>
              <Checkbox checked={isChecked} onChange={(e) => this.onChangeServerUri(e, item.server)}>
                {item.server}&nbsp;({item.count})
              </Checkbox>
            </p>
          )
        })}        
        </Panel>
        </Collapse>
      </span>
    )
  }
}

export default ServerFilter;